import * as React from 'react';
import styles from './list-view-folder.scss';
import { MdFolder } from 'react-icons/md';
import { IoMdArrowDropright } from 'react-icons/io';
import { ComplexValue } from 'app/types-shared';

export interface ListViewFolderProps {
  option: ComplexValue<number>;
  onClick: (value: ComplexValue<number>[]) => void;
  breadcrumbs: ComplexValue<number>[];
  isActive: boolean;
}

export const ListViewFolder = (props: ListViewFolderProps) => {

  const onClick = () => props.onClick(props.breadcrumbs ? [...props.breadcrumbs, props.option] : [props.option]);

  return (
    <div className={`${styles.listViewFolder} ${props.isActive ? styles.listViewFolderActive : ''}`} onClick={onClick}>
      <div className={styles.listViewFolderMainContent}>
        <div className={`${styles.listViewFolderIcon} ${props.isActive ? styles.listViewFolderIconActive : ''}`}>
          <MdFolder height="1.2em" width="1.2em" />
        </div>
        <div className={styles.listViewFolderTitle}>{props.option.description}</div>
      </div>
      <div className={`${styles.listViewFolderArrow} ${props.isActive ? styles.listViewFolderArrowActive : ''}`}>
        <IoMdArrowDropright height="1.2em" width="1.2em" />
      </div>
    </div>
  );
};
